import { createAsyncThunk } from '@reduxjs/toolkit'
import { loadingActions } from 'loankeeper-common/components/hocs/LazyLoading'
import { LookupType, LookupsServerData } from '@lk/api'

import { ThunkApi } from '../index.d'
import { getLookupsByType } from './lookups.selectors'

interface LoadLookupPayload {
  type: LookupType
  lookups: LookupsServerData
}

export const loadLookupsByType = createAsyncThunk<LoadLookupPayload, LookupType, ThunkApi>(
  '[LOOKUPS] LOAD_LOOKUPS',
  async (type, { extra, rejectWithValue }) => {
    loadingActions?.start?.()

    const res = await extra.api.lookups.get(type)

    const { success, data } = res

    loadingActions?.stop?.()

    if (success) {
      return {
        type,
        lookups: data,
      }
    }

    return rejectWithValue('Error while loading lookups')
  },
)

export const loadCitiesByCountryId = createAsyncThunk<any, string, ThunkApi>(
  '[LOOKUPS] LOAD_LOOKUPS',
  async (countryId: string, { extra, rejectWithValue }) => {
    loadingActions.start()

    const { success, data } = await extra.api.lookups.getCitiesByCountryID(LookupType.City, countryId)

    loadingActions.stop()

    if (success && data) {
      return {
        type: LookupType.City,
        lookups: data,
      }
    }

    return rejectWithValue('Error while loading lookups')
  },
)

export const loadLookupsByTypeIfNeeded = (type: LookupType) => async (dispatch, getState) => {
  const lookups = getLookupsByType(getState(), type)

  if (!lookups) {
    await dispatch(loadLookupsByType(type))
  }
}
